var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary"},[_c('div',[_c('a',{style:({ 'font-size': _vm.fontSize }),attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.expand([], _vm.dataChart.metric_name)}}},[_vm._v(_vm._s(_vm.metric))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.dataChart.metric_name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b92a9e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/ReportChart/Summary.vue
// module id = null
// module chunks = 